module.exports = __webpack_public_path__ + "img/face69.5bac82d9.gif";